/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfReportParam } from '../../models/data-page-of-report-param';

export interface ReportParamGet$Params {
  reportId?: number;
  pageSize?: number;
  pageNumber?: number;
}

export function reportParamGet(http: HttpClient, rootUrl: string, params?: ReportParamGet$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfReportParam>> {
  const rb = new RequestBuilder(rootUrl, reportParamGet.PATH, 'get');
  if (params) {
    rb.query('reportId', params.reportId, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('pageNumber', params.pageNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfReportParam>;
    })
  );
}

reportParamGet.PATH = '/api/ReportParam/reportparam/list';
